/**
 * Utilities for managing "Keep me logged in" preference for SSO users
 */
import { ippLocalStorage } from '../local-storage/ippLocalStorage'

const KEEP_LOGGED_IN_KEY = 'keepMeLoggedIn'

/**
 * Set the "keep me logged in" preference
 */
export const setKeepLoggedIn = (enabled: boolean): void => {
  if (enabled) {
    ippLocalStorage.setItem(KEEP_LOGGED_IN_KEY, 'true')
  } else {
    localStorage.removeItem(KEEP_LOGGED_IN_KEY)
  }
}

/**
 * Get the "keep me logged in" preference
 */
export const getKeepLoggedIn = (): boolean => localStorage.getItem(KEEP_LOGGED_IN_KEY) === 'true'

/**
 * Clear the preference
 */
export const clearKeepLoggedIn = (): void => {
  localStorage.removeItem(KEEP_LOGGED_IN_KEY)
}

/**
 * Check if user is a third-party SSO user from JWT
 *
 * Only returns true for third-party SSO users (not internal users).
 * Internal users now receive refresh tokens, so they don't need the
 * localStorage-based SSO auto-redirect flow.
 */
export const isSsoUser = (token?: string): boolean => {
  if (!token) return false

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.user_type === 'sso'
  } catch (e) {
    return false
  }
}

/**
 * Extract email from JWT
 */
export const getEmailFromJWT = (token?: string): string | null => {
  if (!token) return null

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.email || null
  } catch (e) {
    console.error('[Keep Logged In] Failed to extract email from JWT:', e)
    return null
  }
}
